import { render, staticRenderFns } from "./Scaffold.vue?vue&type=template&id=5b0b0cad&scoped=true"
import script from "./Scaffold.vue?vue&type=script&lang=js"
export * from "./Scaffold.vue?vue&type=script&lang=js"
import style0 from "./Scaffold.vue?vue&type=style&index=0&id=5b0b0cad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0b0cad",
  null
  
)

export default component.exports